import {
  CompanyStructureCalendarEventResponse,
  CompanyStructureCalendarEventResponseItem
} from '@/types/service-response'

export class CalendarEvent {
  private constructor (
    readonly id: number,
    readonly eventId: number, // kalenderArtID
    readonly eventName: string,
    readonly profitCenterId: number,
    readonly profitCenterName: string,
    readonly color: string | null,
    readonly isPlannable: boolean,
    readonly language: number
  ) {}

  public static createListFromResponse (data: CompanyStructureCalendarEventResponse): Array<CalendarEvent> {

    return data.map((item: CompanyStructureCalendarEventResponseItem) => {
      return new CalendarEvent(
        item.ID,
        item.kalenderArtID,
        item.KalenderArtName,
        item.ProfitCenterID,
        item.ProfitCenterName,
        item.ProfitCenterArtColor,
        item.ProfitCenterArtPlanable,
        item.Sprache
      )
    })
  }
}
